import * as React from "react";

export const FilterIconBlue = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#6587FF"
      d="M.62.684v1.758l6 7.5v8.742l4.5-3.375V9.942l6-7.5V.684H.62Zm1.71 1.5h13.078l-5.39 6.75H7.72l-5.39-6.75Zm5.79 8.25h1.5v4.125l-1.5 1.125v-5.25Z"
    />
  </svg>
);
